export default "__VITE_ASSET__BWqgBmxu__"